let arrImages = document.querySelectorAll('.js-image-animation');
let arrText = document.querySelectorAll('.js-text-animation');


const textObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.image.classList.add('opacity-100');
            entry.target.image.classList.remove('opacity-0');
        } else {
            entry.target.image.classList.add('opacity-0');
            entry.target.image.classList.remove('opacity-100');
        }
    });
});

arrText.forEach((el, index) => {
    textObserver.observe(el);
    el.image = arrImages[index];
});